module.exports = __webpack_public_path__ + "app/principal/principal-buyer-1a89a1cR.html";